


















import Vue from "vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FloatingMenuCheckButton",
  components: {
    Body,
    OccButton
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    isShowBottomSeparator: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  computed: {
    bottomSeparatorClass() {
      return { "bottom--separator": this.isShowBottomSeparator };
    }
  },
  methods: {
    handleClick() {
      this.$emit("click", this.value);
    }
  }
});
